import SimpleHeader from '../../components/SimpleHeader/SimpleHeader.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import styles from './TermsPage.module.css';

/**
 * 이용약관 페이지 (원본: WWW/terms.html)
 * 공지일 2026.06.24 / 시행일 2026.07.01
 */
export default function TermsPage() {
  return (
    <>
      <SimpleHeader />

      <main className={styles.main}>
        <div className="wrap">
          <h1 className={styles.h1}>이용약관</h1>
          <p className={styles.updated}>시행일자: 2026년 07월 01일</p>

          {/* 제1장 총칙 */}
          <div className={styles.chapterTitle}>제1장 총칙</div>

          <section className={styles.article}>
            <h2 className={styles.h2}>제1조 [목적]</h2>
            <p>
              이 약관은 ㈜비상교육(이하 &ldquo;회사&rdquo;)이 제공하는 잉글리시팝(https://www.englishpop.co.kr)
              서비스의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.
            </p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제2조 [용어정의]</h2>
            <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
            <div className={styles.term}>
              <dt>1) &ldquo;이용자&rdquo;</dt>
              <dd>라 함은 회사의 사이트에 접속하여 이 약관에 따라 회사가 제공하는 콘텐츠 및 제반 서비스를 이용하는 회원 및 비회원을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>2) &ldquo;회원&rdquo;</dt>
              <dd>이라 함은 회사와 이용계약을 체결하고 이용자 아이디(ID)를 부여받은 이용자로서 회사의 정보를 지속적으로 제공받으며 회사가 제공하는 서비스를 지속적으로 이용할 수 있는 자를 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>3) &ldquo;학생회원&rdquo;</dt>
              <dd>이라 함은 학습서비스를 이용하는 회원을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>4) &ldquo;학부모회원&rdquo;</dt>
              <dd>이라 함은 학생회원의 보호자로서 학생의 학습현황 등을 조회하기 위하여 가입한 회원을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>5) &ldquo;가맹점장회원&rdquo;</dt>
              <dd>이라 함은 회사와 가맹계약을 체결한 회원을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>6) &ldquo;선생님회원&rdquo;</dt>
              <dd>이라 함은 가맹점에 소속되어 서비스를 이용하는 회원을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>7) &ldquo;비회원&rdquo;</dt>
              <dd>이라 함은 회원가입을 하지 않고 사이트에 접속하여 서비스를 이용하는 자를 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>8) &ldquo;콘텐츠&rdquo;</dt>
              <dd>라 함은 회사가 서비스를 통하여 제공하는 문자, 음성, 음향, 이미지, 영상, 프로그램, 학습자료, 평가문항 및 그 밖에 전자적 형태로 제작 또는 처리된 자료나 정보를 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>9) &ldquo;아이디(ID)&rdquo;</dt>
              <dd>라 함은 회원의 식별과 서비스 이용을 위하여 회사 또는 가맹점이 부여하거나 회원이 설정하는 문자 또는 숫자의 조합을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>10) &ldquo;비밀번호(PASSWORD)&rdquo;</dt>
              <dd>라 함은 회원임을 확인하고 회원정보를 보호하기 위하여 회원, 회사 또는 가맹점이 설정하거나 부여한 문자, 숫자 또는 기호의 조합을 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>11) &ldquo;운영자(관리자)&rdquo;</dt>
              <dd>라 함은 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람 혹은 기관 또는 회사를 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>12) &ldquo;게시물&rdquo;</dt>
              <dd>이라 함은 회원이 서비스를 이용함에 있어 회사의 사이트에 게시한 문자, 부호, 음향, 화상, 동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크, 댓글 등의 정보를 말합니다.</dd>
            </div>
            <div className={styles.term}>
              <dt>13)</dt>
              <dd> 전항 각호의 용어를 제외한 용어의 정의는 거래 관행 및 관계 법령에 따릅니다.</dd>
            </div>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제3조 [회사 신원정보 등의 제공]</h2>
            <p>회사는 상호, 대표자 성명, 주소, 전화번호(소비자 불만처리 연락처 포함), 전자우편주소, 사업자등록번호, 통신판매업 신고번호 및 개인정보 보호책임자 등을 이용자가 쉽게 확인할 수 있도록 서비스 초기화면에 게시합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제4조 [약관의 게시 등]</h2>
            <p>1) 회사는 이용자가 별도의 연결화면을 통하여 약관을 확인할 수 있도록 서비스 내에 게시합니다.</p>
            <p>2) 회사는 약관의 중요한 내용을 굵은 문자 등으로 명확하게 표시하여 이용자가 알아보기 쉽도록 하고 있습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제5조 [약관의 개정]</h2>
            <p>1) 회사는 관계 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</p>
            <p>
              2) 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여, 개정 전 약관과 함께 적용일 7일
              전부터 회사 서비스에서 확인할 수 있도록 게시하며, 기존 회원에게는 본 약관 제7조의 방법을 통하여 약관
              개정사실을 통지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전
              유예기간을 두고 공지하며, 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록
              표시합니다. 회사는 개정 약관을 공지하거나 통지할 때 회원이 적용일까지 명시적으로 거부 의사를 표시하지
              않는 경우 개정 약관에 동의한 것으로 본다는 사실과, 개정 약관에 동의하지 않는 경우 회원 탈퇴를 할 수
              있다는 사실을 함께 안내합니다.
            </p>
            <p>3) 기존 회원이 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 회원 탈퇴를 할 수 있습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제6조 [약관의 효력]</h2>
            <p>1) 본 약관은 이용자가 약관에 동의하여 회원가입을 완료하거나, 회사 또는 가맹점을 통하여 회원 계정이 생성되고 서비스를 이용함으로써 효력이 발생합니다.</p>
            <p>2) 회사가 제5조 제2항에 따라 개정 약관, 적용일, 변경 사유 및 동의 거부 방법을 명확히 공지 또는 통지하였음에도 회원이 적용일까지 명시적인 거부 의사를 표시하지 않은 경우에는 개정 약관에 동의한 것으로 봅니다.</p>
            <p>
              3) 본 약관에 명시되지 않은 사항에 대해서는 &ldquo;약관의 규제에 관한 법률&rdquo;, &ldquo;전자상거래
              등에서의 소비자보호에 관한 법률&rdquo;, &ldquo;학원의 설립·운영 및 과외교습에 관한 법률&rdquo;,
              &ldquo;콘텐츠 산업 진흥법&rdquo; 및 기타 관련법령 또는 상관례에 따릅니다.
            </p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제7조 [&ldquo;회원&rdquo;에 대한 통지]</h2>
            <p>1) 회사는 회원에게 알려야 할 사항이 발생하는 경우, 회원가입 시 회원이 공개한 전자우편, SMS, 서비스 내 알림, 팝업, 앱 푸시(Push) 등의 방법으로 통지할 수 있습니다.</p>
            <p>2) 회사는 회원 전체에 대한 통지의 경우 7일 이상 회사 웹사이트 게시판에 게시함으로써 전항의 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래 및 사이트의 이용과 관련하여 중대한 영향을 미치는 사항에 대하여는 30일 이상 전항과 동일한 방법으로 별도 통지할 수 있습니다.</p>
          </section>

          {/* 제2장 서비스 이용계약 */}
          <div className={styles.chapterTitle}>제2장 서비스 이용계약</div>

          <section className={styles.article}>
            <h2 className={styles.h2}>제8조 [이용신청]</h2>
            <p>1) 서비스의 이용을 원하는 고객은 회사가 정한 이용신청 절차에 따라 온라인 또는 회사가 지정하는 방법으로 이용을 신청하여야 합니다.</p>
            <p>2) 고객은 본인의 실명으로 이용신청을 하여야 하며, 회사는 이 약관의 주요 내용을 고지하고 이용신청 고객의 동의를 받아 가입을 처리합니다.</p>
            <p>3) 미성년자의 이용신청과 관련하여 관계 법령상 법정대리인의 동의가 필요한 경우, 회사는 법정대리인의 동의를 확인할 수 있습니다. 만 14세 미만 이용자의 회원가입 및 개인정보 처리에 관한 사항은 제9조에 따릅니다.</p>
            <p>4) 회사는 다음 각 호의 어느 하나에 해당하는 신청에 대하여는 승낙을 하지 않거나, 승낙한 이후라도 이를 취소할 수 있습니다.</p>
            <ol className={styles.legal}>
              <li>가맹점의 회원 모집이 종료되었거나 서비스 제공이 어려운 경우</li>
              <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
              <li>허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
              <li>같은 이용자가 다른 ID로 이중 등록을 한 경우</li>
              <li>타인에게 본인의 ID를 공유하여 사용하는 경우</li>
              <li>본 약관 제17조(회원의 의무)를 위반하여 회원자격이 상실된 이력이 있는 경우</li>
              <li>회사가 통제하기 곤란한 사정으로 정상적인 서비스 이용에 지장이 있는 경우</li>
              <li>기타 회사가 필요하다고 인정되는 경우</li>
              <li>기타 회사가 정한 이용 신청 요건에 적합하지 않다고 판단되는 경우</li>
            </ol>
            <p>5) 회사는 서비스 관련 설비의 여유가 없거나 기술상 또는 업무상 문제가 있는 경우에는 이용신청의 승낙을 유보할 수 있습니다.</p>
            <p>6) 회사는 제4항 또는 제5항에 따라 회원가입 신청을 승낙하지 아니하거나 승낙을 유보한 경우에는 그 사실과 사유를 신청자에게 알려야 합니다. 다만, 회사의 귀책사유 없이 신청자에게 통지할 수 없는 경우에는 예외로 합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제9조 [만 14세 미만 이용자의 회원가입에 관한 특칙]</h2>
            <p>1) 만 14세 미만의 이용자는 회사가 제공하는 개인정보처리방침을 충분히 확인한 후 법정대리인(부모 등)의 동의를 받아 회원가입을 신청하여야 합니다.</p>
            <p>2) 회사는 만 14세 미만의 이용자가 회원가입을 신청하는 경우 법정대리인의 동의 여부를 확인하기 위한 별도의 안내 또는 확인 절차를 거칠 수 있습니다.</p>
            <p>3) 만 14세 미만의 이용자는 회사가 법정대리인의 동의 여부를 확인할 수 있도록 회원가입 시 법정대리인의 성명 및 연락처 등의 정보를 제공하여야 합니다.</p>
            <p>4) 회사는 법정대리인의 동의 확인 절차를 거치지 않은 만 14세 미만 이용자의 회원가입을 거절하거나 회원자격을 취소할 수 있습니다.</p>
            <p>
              5) 만 14세 미만 회원의 법정대리인(부모 등)은 자녀의 개인정보에 대한 열람·정정·삭제를 요구하거나
              회원가입에 대한 동의를 철회할 수 있으며, 회사는 관계 법령에 따라 지체 없이 필요한 조치를 합니다. 이
              경우 회사는 법정대리인임을 확인하기 위하여 필요한 증빙서류의 제출을 요청할 수 있습니다.
            </p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제10조 [회원정보의 변경]</h2>
            <p>1) 회원은 회원가입 시 기재한 사항이 변경된 경우에는 회사가 제공하는 방법에 따라 지체 없이 해당 정보를 수정하거나 변경을 요청하여야 합니다.</p>
            <p>2) 회원이 제1항의 변경사항을 수정하지 아니하여 발생하는 불이익에 대하여 회사는 책임을 지지 않습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제11조 [회원의 아이디 및 비밀번호 관리]</h2>
            <p>1) 회원은 회사 또는 가맹점으로부터 부여받은 아이디와 본인이 설정하거나 부여받은 비밀번호를 선량한 관리자의 주의로 관리하여야 하며, 이를 타인에게 제공하거나 제3자가 이용하도록 하여서는 안 됩니다.</p>
            <p>2) 회원은 자신의 아이디 또는 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 회사 또는 가맹점에 알려야 합니다.</p>
            <p>3) 회사는 회원의 개인정보 보호 및 서비스의 안전한 운영을 위하여 필요한 경우 비밀번호 변경 등 필요한 조치를 요구할 수 있으며, 회원은 특별한 사정이 없는 한 이에 협조하여야 합니다.</p>
            <p>4) 회사는 회원이 제2항 및 제3항의 의무를 이행하지 아니하여 발생한 손해 또는 불이익에 대하여 책임을 지지 않습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제12조 [이용계약의 해지, 회원 탈퇴 및 자격 상실 등]</h2>
            <p>1) 회원은 언제든지 회원 탈퇴를 요청할 수 있습니다. 다만, 회원의 유형에 따른 탈퇴 절차는 다음 각 호와 같습니다.</p>
            <ol className={styles.legal}>
              <li>학생회원, 학부모회원 및 선생님회원은 가맹점을 통하여 회원 탈퇴를 요청할 수 있으며, 가맹점이 회원 탈퇴 절차를 완료함으로써 탈퇴가 처리됩니다.</li>
              <li>가맹점장회원은 회사와의 가맹계약 종료 또는 회사가 정한 절차에 따라 회원 탈퇴를 신청할 수 있습니다.</li>
              <li>가맹점장회원이 회사와의 가맹계약을 종료하는 경우 서비스 이용계약도 함께 종료되며 회원자격은 상실됩니다.</li>
            </ol>
            <p>2) 회원이 탈퇴한 경우 개인정보는 관계 법령 및 회사의 개인정보처리방침에서 정한 바에 따라 처리되며, 탈퇴 후 재가입 시 기존의 학습이력 및 회원정보는 복구되지 않습니다.</p>
            <p>3) 회사는 회원이 다음 각 호의 어느 하나에 해당하는 경우 서비스 이용을 제한하거나 회원자격을 상실시킬 수 있습니다.</p>
            <ol className={styles.legal}>
              <li>본 약관 또는 관계 법령을 위반한 경우</li>
              <li>타인의 명의 또는 계정을 도용하거나 부정하게 이용한 경우</li>
              <li>허위 정보를 등록하거나 회사에 제공한 경우</li>
              <li>서비스의 정상적인 운영을 방해하거나 다른 이용자의 서비스 이용을 현저히 저해한 경우</li>
              <li>기타 회사가 서비스 운영상 회원자격 유지가 부적절하다고 판단하는 경우</li>
            </ol>
            <p>4) 회사는 제3항에 따라 회원의 이용을 제한하거나 회원자격을 상실시키는 경우, 관계 법령 또는 본 약관에서 달리 정한 경우를 제외하고 사전에 그 사유를 회원에게 통지합니다.</p>
          </section>

          {/* 제3장 서비스 이용 */}
          <div className={styles.chapterTitle}>제3장 서비스 이용</div>

          <section className={styles.article}>
            <h2 className={styles.h2}>제13조 [서비스의 제공]</h2>
            <p>1) 회사는 회원에게 다음 각 호의 서비스를 제공합니다.</p>
            <ol className={styles.legal}>
              <li>온라인 학습 콘텐츠 제공</li>
              <li>학습 진도 및 학습 결과 관리</li>
              <li>사전 테스트 및 평가 서비스</li>
              <li>학습 이력 조회 및 관리</li>
              <li>학부모 학습 조회 서비스</li>
              <li>기타 회사가 제공하는 부가서비스</li>
            </ol>
            <p>2) 회사는 운영상 또는 기술상의 필요에 따라 서비스의 전부 또는 일부를 변경하거나 추가할 수 있으며, 변경사항이 회원의 권리 또는 의무에 중대한 영향을 미치는 경우에는 제7조에서 정한 방법에 따라 사전에 안내합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제14조 [서비스 이용환경]</h2>
            <p>1) 학생회원은 회사 또는 가맹점을 통하여 제공되는 학습기기(PAD)를 이용하여 서비스를 이용함을 원칙으로 합니다.</p>
            <p>2) 학부모회원은 회사가 제공하는 모바일 웹을 통하여 학생의 학습현황, 학습 결과 및 학습 리포트 등을 조회할 수 있습니다. 단, 학습 콘텐츠의 이용은 제한될 수 있습니다.</p>
            <p>3) 가맹점장회원 및 선생님회원은 회사가 제공하거나 회사가 지원하는 학습기기(PAD, 전자칠판), 웹브라우저 등 권장 이용환경에서 서비스를 이용할 수 있습니다. 권장 이용환경을 충족하지 아니하는 경우 일부 서비스의 이용이 제한되거나 정상적으로 동작하지 않을 수 있습니다.</p>
            <p>4) 서비스 이용을 위한 지원 기기, 운영 환경 및 기술사양은 회사 홈페이지 또는 고객센터를 통하여 안내합니다.</p>
            <p>5) 회사가 지원하지 않는 기기 또는 운영 환경에서 서비스를 이용하거나, 인터넷 연결 상태, 통신환경 또는 단말기의 성능 등 회사의 관리 범위를 벗어난 사유로 발생하는 서비스 이용상의 제한 또는 장애에 대하여 회사는 책임을 지지 않습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제15조 [서비스의 변경 및 중단]</h2>
            <p>1) 회사는 다음 각 호의 어느 하나에 해당하는 경우 서비스의 전부 또는 일부를 변경하거나 일시적으로 중단할 수 있습니다.</p>
            <ol className={styles.legal}>
              <li>시스템 점검 및 유지보수</li>
              <li>설비의 장애 또는 보수</li>
              <li>통신사업자의 서비스 장애</li>
              <li>천재지변, 국가비상사태 등 불가항력적인 사유</li>
              <li>기타 안정적인 서비스 운영을 위하여 회사가 필요하다고 인정하는 경우</li>
            </ol>
            <p>2) 회사는 서비스 변경 또는 중단이 예정된 경우 제7조에서 정한 방법으로 사전에 회원에게 안내합니다. 다만, 긴급한 장애 등 사전 안내가 어려운 경우에는 사후에 안내할 수 있습니다.</p>
            <p>3) 회사는 회원의 학습이력, 학습 결과 등 서비스 이용기록을 서비스 제공 및 학습관리 목적으로 처리할 수 있으며, 구체적인 보유기간 및 파기에 관한 사항은 개인정보처리방침에서 정한 바에 따릅니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제16조 [회사의 의무]</h2>
            <p>1) 회사는 관계 법령 및 본 약관이 정하는 바에 따라 안정적이고 지속적인 서비스 제공을 위하여 최선을 다합니다.</p>
            <p>2) 회사는 관계 법령 및 개인정보처리방침에 따라 회원의 개인정보를 안전하게 보호하기 위하여 필요한 기술적·관리적 보호조치를 취합니다.</p>
            <p>3) 회사는 회원으로부터 제기되는 의견 또는 불만이 정당하다고 인정되는 경우에는 이를 지체 없이 처리하도록 노력하며, 필요한 경우 처리 결과를 회원에게 안내합니다.</p>
            <p>4) 회사는 서비스 운영에 필요한 사항, 약관 변경, 개인정보처리방침 변경, 서비스 점검 및 장애 안내 등 회원이 알아야 할 중요한 정보를 제7조에서 정한 방법에 따라 제공합니다.</p>
            <p>5) 회사는 안정적인 서비스 제공을 위하여 시스템 점검, 유지보수 및 서비스 개선을 실시할 수 있으며, 회원의 권리 또는 의무에 중대한 영향을 미치는 경우에는 제7조에서 정한 방법에 따라 사전에 안내합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제17조 [회원의 의무]</h2>
            <p>1) 회원은 관계 법령, 본 약관 및 회사가 정한 운영정책을 준수하여야 하며, 다음 각 호의 행위를 하여서는 안 됩니다.</p>
            <ol className={styles.legal}>
              <li>타인의 개인정보 또는 계정을 도용하거나 무단으로 사용하는 행위</li>
              <li>자신의 아이디(ID) 또는 비밀번호를 타인에게 제공, 공유, 양도 또는 대여하는 행위</li>
              <li>회사가 제공하는 콘텐츠, 학습자료 및 서비스를 회사의 사전 승인 없이 복제, 녹화, 캡처, 편집, 전송, 배포, 판매 또는 상업적으로 이용하는 행위</li>
              <li>회사의 시스템을 변조하거나 비정상적인 방법으로 서비스를 이용하거나 서비스의 정상적인 운영을 방해하는 행위</li>
              <li>허위 정보를 등록하거나 타인의 권리 또는 명예를 침해하는 행위</li>
              <li>회사가 제공하는 학습기기(PAD)의 보안설정을 임의로 변경하거나 승인되지 않은 방법으로 서비스를 이용하는 행위</li>
              <li>관계 법령, 본 약관 또는 회사의 운영정책을 위반하는 행위</li>
              <li>기타 회사의 정상적인 서비스 운영을 방해하거나 다른 회원의 서비스 이용을 저해하는 행위</li>
            </ol>
            <p>2) 회원은 자신의 계정 및 비밀번호를 안전하게 관리하여야 하며, 이를 소홀히 하여 발생한 손해 또는 불이익에 대한 책임은 회원에게 있습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제18조 [부정이용의 금지]</h2>
            <p>1) 회사는 다음 각 호의 어느 하나에 해당하는 행위를 부정이용으로 봅니다.</p>
            <ol className={styles.legal}>
              <li>타인의 계정을 도용하거나 타인과 계정을 공유하여 서비스를 이용하는 행위</li>
              <li>하나의 계정을 여러 사람이 공동으로 이용하는 행위</li>
              <li>회사의 사전 승인 없이 콘텐츠 또는 학습자료를 복제, 녹화, 캡처, 편집, 전송, 배포 또는 상업적으로 이용하는 행위</li>
              <li>회사의 시스템을 비정상적인 방법으로 이용하거나 서비스의 정상적인 운영을 방해하는 행위</li>
              <li>회사가 제공하는 학습기기(PAD)의 보안설정을 변경하거나 비인가 프로그램을 설치하는 등 서비스의 정상적인 운영을 저해하는 행위</li>
              <li>기타 회사가 서비스의 정상적인 운영을 저해하거나 부정한 이용으로 판단하는 행위</li>
            </ol>
            <p>2) 회사는 부정이용이 확인되는 경우 사안의 경중에 따라 다음 각 호의 조치를 할 수 있습니다.</p>
            <ol className={styles.legal}>
              <li>경고 또는 시정 요구</li>
              <li>서비스 이용의 일시 제한</li>
              <li>회원자격 제한 또는 이용계약의 해지</li>
              <li>관계 법령에 따른 민·형사상 조치</li>
            </ol>
            <p>3) 회원은 제2항에 따른 조치에 대하여 이의가 있는 경우 회사에 소명자료를 제출할 수 있으며, 회사는 제출된 자료를 검토하여 필요한 조치를 합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제19조 [정보의 제공]</h2>
            <p>1) 회사는 서비스 운영, 시스템 점검, 서비스 변경, 학습 안내, 공지사항, 이벤트 등 서비스 이용에 필요한 정보를 제7조에서 정한 방법에 따라 회원에게 제공할 수 있습니다.</p>
            <p>2) 회사는 관계 법령에 따라 광고성 정보를 전송하는 경우에는 회원의 사전 동의를 받은 경우에 한하여 제공합니다. 다만, 관계 법령에 따라 별도의 동의 없이 제공할 수 있는 정보는 예외로 합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제20조 [저작권]</h2>
            <p>1) 회사가 제공하는 모든 콘텐츠, 프로그램, 학습자료 및 서비스에 관한 저작권 및 지식재산권은 회사 또는 정당한 권리자에게 있습니다.</p>
            <p>2) 회사가 제공하는 콘텐츠에는 인공지능(AI) 기술을 활용하여 생성 또는 가공된 콘텐츠가 포함될 수 있으며, 이에 관한 저작권 및 지식재산권은 관계 법령 및 계약에 따라 회사 또는 정당한 권리자에게 귀속됩니다.</p>
            <p>3) 회원은 회사의 사전 서면 동의 없이 콘텐츠를 복제, 녹화, 캡처, 편집, 전송, 배포, 출판, 판매하거나 인공지능(AI) 모델의 학습, 학습데이터 구축 또는 AI 기반 서비스의 개발·운영 등에 이용하는 등 회사의 저작권 또는 지식재산권을 침해하는 행위를 하여서는 아니 됩니다.</p>
            <p>4) 회원은 회사가 제공하는 콘텐츠를 이용하여 2차적 저작물을 제작하거나 이를 상업적으로 이용하여서는 아니 됩니다.</p>
            <p>5) 본 조를 위반하여 발생하는 모든 책임은 해당 회원에게 있으며, 회사는 관계 법령에 따라 민·형사상의 책임을 물을 수 있습니다.</p>
          </section>

          {/* 제4장 서비스 이용의 제한·변경 및 종료 */}
          <div className={styles.chapterTitle}>제4장 서비스 이용의 제한·변경 및 종료</div>

          <section className={styles.article}>
            <h2 className={styles.h2}>제21조 [서비스 이용의 제한]</h2>
            <p>1) 회사는 회원이 본 약관 제17조(회원의 의무) 또는 제18조(부정이용의 금지)를 위반한 경우 사안의 경중에 따라 경고, 서비스 이용 제한, 회원자격 제한 또는 회원자격 상실 등의 조치를 할 수 있습니다.</p>
            <p>2) 회사는 제1항에 따른 조치를 하는 경우 제7조에서 정한 방법에 따라 회원 또는 필요한 경우 해당 가맹점에 그 사실 및 사유를 통지합니다. 다만, 긴급한 조치가 필요한 경우에는 사후에 통지할 수 있습니다.</p>
            <p>3) 회원 또는 해당 가맹점은 회사의 조치에 대하여 정당한 사유가 있는 경우 소명자료를 제출할 수 있으며, 회사는 이를 검토하여 필요한 조치를 취합니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제22조 [서비스 이용의 변경 및 종료]</h2>
            <p>1) 회원에 대한 서비스는 회사의 운영정책 및 가맹점 운영체계에 따라 제공됩니다.</p>
            <p>2) 회원의 서비스 이용기간, 이용중단, 서비스 종료 및 기타 이용조건은 회사의 운영정책 및 가맹점 운영절차에 따라 처리될 수 있습니다.</p>
            <p>3) 학생회원 및 학부모회원의 서비스 이용과 관련된 이용기간 변경, 이용 종료 및 환불 등은 해당 가맹점의 운영절차 및 관계 법령에 따라 처리됩니다. 가맹점장회원이 회사와 직접 체결한 거래의 취소, 변경 및 환불은 회사의 운영정책, 개별 계약 및 관계 법령에 따릅니다.</p>
            <p>4) 회원은 서비스 이용과 관련된 학습권 등록, 이용기간, 이용문의 등 가맹점 운영에 관한 사항은 우선 해당 가맹점을 통하여 안내 및 처리받을 수 있습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제23조 [과오금의 환급]</h2>
            <p>1) 회사와 직접 거래하는 회원(가맹점장 등)에 대하여 회사의 귀책사유로 과오금이 발생한 경우 회사는 관계 법령에 따라 과오금을 환급합니다.</p>
            <p>2) 회사와 직접 거래하는 회원의 귀책사유로 과오금이 발생한 경우 회사는 환급에 필요한 비용을 합리적인 범위에서 공제할 수 있습니다.</p>
            <p>3) 과오금의 환급방법 및 절차는 관계 법령 및 회사의 운영정책에 따릅니다.</p>
          </section>

          {/* 제5장 기타 */}
          <div className={styles.chapterTitle}>제5장 기타</div>

          <section className={styles.article}>
            <h2 className={styles.h2}>제24조 [면책조항]</h2>
            <p>1) 회사는 천재지변, 전쟁, 폭동, 화재, 정전, 국가비상사태, 통신사업자의 서비스 장애 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 회사의 귀책사유가 없는 한 책임을 지지 않습니다.</p>
            <p>2) 회사는 회원 또는 가맹점의 인터넷 이용환경, 통신환경, 회원이 사용하는 단말기의 장애 또는 회원의 귀책사유로 인하여 발생한 서비스 이용 장애에 대하여 회사의 귀책사유가 없는 한 책임을 지지 않습니다.</p>
            <p>3) 회사는 서비스 이용으로 회원이 기대하는 학습효과 또는 교육성과를 보장하지 않으며, 회원의 이용방법, 학습환경 또는 귀책사유로 발생한 결과에 대하여 책임을 지지 않습니다.</p>
            <p>4) 회사는 회원 상호 간, 회원과 가맹점 또는 회원과 제3자 간에 서비스를 매개로 발생한 분쟁에 대하여 회사의 귀책사유가 없는 한 책임을 지지 않습니다.</p>
            <p>5) 회사는 제15조에 따라 서비스를 일시적으로 제한하거나 중단할 수 있으며, 회사의 고의 또는 과실이 없는 경우 그로 인하여 발생한 손해에 대하여 책임을 지지 않습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제25조 [분쟁의 해결]</h2>
            <p>1) 회사는 서비스 이용과 관련하여 회원으로부터 제기되는 의견, 불만 또는 민원을 신속하고 성실하게 처리하기 위하여 노력합니다.</p>
            <p>2) 회사와 회원 간 분쟁이 발생한 경우 당사자는 상호 협의를 통하여 원만하게 해결하도록 노력합니다.</p>
            <p>3) 협의로 해결되지 아니한 분쟁은 관계 법령에서 정한 절차에 따라 해결하며, 필요한 경우 콘텐츠분쟁조정위원회 등 관계 법령에 따른 분쟁조정기관에 조정을 신청할 수 있습니다.</p>
          </section>

          <section className={styles.article}>
            <h2 className={styles.h2}>제26조 [관할법원]</h2>
            <p>1) 회사와 회원 간 발생한 분쟁에 관한 소송은 「민사소송법」 등 관계 법령에 따릅니다.</p>
            <p>2) 회사와 회원 간 제기되는 소송은 제소 당시 이용자의 주소를 관할하는 법원을 관할법원으로 하며, 주소가 없는 경우에는 거소를 관할하는 법원을 관할법원으로 합니다.</p>
            <p>3) 제소 당시 이용자의 주소 또는 거소가 명확하지 아니한 경우에는 「민사소송법」이 정하는 바에 따릅니다.</p>
          </section>

          <div className={styles.addendum}>
            <h2 className={styles.h2}>부칙</h2>
            <p>제1조 [시행일]</p>
            <p>1) 본 약관은 아래의 공지일 및 시행일부터 적용됩니다.</p>
            <ul className={styles.plain}>
              <li>공지일 : 2026년 6월 24일</li>
              <li>시행일 : 2026년 7월 1일</li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
